import React, { useState, useEffect, useRef, useCallback } from 'react';
import './DelFi.css';

// Helper function for responsive window sizing
function useWindowSize() {
  const getSize = () => {
    const styles = getComputedStyle(document.documentElement);
    const availableWidth = parseInt(styles.getPropertyValue('--available-width')) || window.innerWidth;
    const availableHeight = parseInt(styles.getPropertyValue('--available-height')) || window.innerHeight;
    
    return {
      width: window.innerWidth,
      dwidth: availableWidth,
      dheight: availableHeight
    };
  };

  const [windowSize, setWindowSize] = useState(getSize);

  useEffect(() => {
    const handleResize = () => {
      setWindowSize(getSize());
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}

// Data Icon (Profit Report)
export const DataIcon = ({ color = "#ccc", size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" style={{ display: "block", margin: "auto" }}>
    <path 
      d="M 12.5 4 C 10.032499 4 8 6.0324991 8 8.5 L 8 39.5 C 8 41.967501 10.032499 44 12.5 44 L 35.5 44 C 37.967501 44 40 41.967501 40 39.5 L 40 18.5 C 39.999923498055665 18.10220151800856 39.841851375478406 17.72072064204925 39.560547 17.439453 L 39.544922 17.423828 L 26.560547 4.4394531 C 26.279279374321604 4.158148687849891 25.897798496343654 4.000076528465977 25.5 4 L 12.5 4 z M 12.5 7 L 24 7 L 24 15.5 C 24 17.967501 26.032499 20 28.5 20 L 37 20 L 37 39.5 C 37 40.346499 36.346499 41 35.5 41 L 12.5 41 C 11.653501 41 11 40.346499 11 39.5 L 11 8.5 C 11 7.6535009 11.653501 7 12.5 7 z M 27 9.1210938 L 34.878906 17 L 28.5 17 C 27.653501 17 27 16.346499 27 15.5 L 27 9.1210938 z M 24.001953 21 C 23.173953 21 22.501953 21.671 22.501953 22.5 L 22.501953 23.167969 C 20.668953 23.665969 19.271484 25.324 19.271484 27.25 C 19.271484 29.593 21.177484 31.5 23.521484 31.5 L 24.751953 31.5 C 25.440953 31.5 26.001953 32.061 26.001953 32.75 C 26.001953 33.352875 25.571578 33.857811 25.001953 33.974609 C 24.920578 33.991295 24.83625 34 24.75 34 L 23.039062 34 C 22.219062 34 21.896797 33.440125 21.841797 33.328125 C 21.471797 32.587125 20.571125 32.290203 19.828125 32.658203 C 19.087125 33.029203 18.788203 33.929875 19.158203 34.671875 C 19.669203 35.691875 20.802 36.765938 22.5 36.960938 L 22.5 37.5 C 22.5 38.329 23.172 39 24 39 C 24.1035 39 24.205117 38.988717 24.302734 38.96875 C 24.986055 38.828982 25.5 38.225375 25.5 37.5 L 25.5 36.923828 C 27.486 36.567828 29 34.837 29 32.75 C 29 32.457125 28.970758 32.170908 28.914062 31.894531 C 28.517195 29.959893 26.801 28.5 24.75 28.5 L 23.519531 28.5 C 22.830531 28.5 22.269531 27.939 22.269531 27.25 C 22.269531 27.16675 22.280229 27.085566 22.298828 27.005859 C 22.429025 26.44791 22.987859 26 23.615234 26 L 24.462891 26 C 25.220891 26 25.484203 26.322875 25.658203 26.671875 C 26.029203 27.413875 26.929875 27.711797 27.671875 27.341797 C 28.412875 26.970797 28.71375 26.070125 28.34375 25.328125 C 27.8975 24.436375 27.226969 23.788234 26.390625 23.40625 C 26.251234 23.342586 26.107379 23.286979 25.958984 23.238281 C 25.81059 23.189584 25.658828 23.146781 25.501953 23.113281 L 25.501953 22.5 C 25.501953 21.671 24.829953 21 24.001953 21 z"
      fill={color}
    />
  </svg>
);

// News Icon
export const NewsIcon = ({ color = "#ccc", size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" style={{ display: "block", margin: "auto" }}>
    <path 
      d="M 2 3 L 2 18 C 2 19.654 3.346 21 5 21 L 19 21 C 20.64497 21 22 19.64497 22 18 L 22 7 L 20 7 L 20 18 C 20 18.56503 19.56503 19 19 19 C 18.448 19 18 18.551 18 18 L 18 3 L 2 3 z M 6 6 L 14 6 L 14 9 L 6 9 L 6 6 z M 6 12 L 14 12 L 14 14 L 6 14 L 6 12 z M 6 16 L 14 16 L 14 18 L 6 18 L 6 16 z"
      fill={color}
    />
  </svg>
);

// Analytics Icon (Graph/Bar)
export const AnalyticsIcon = ({ color = "#ccc", size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" style={{ display: "block", margin: "auto" }}>
    {/* Bar lines */}
    <path d="M 2 21 L 22 21" stroke={color} strokeWidth="1.5" />
    {/* Bars */}
    <rect x="3" y="15" width="3" height="6" rx="1" fill="none" stroke={color} strokeWidth="1.5"/>
    <rect x="8" y="10" width="3" height="11" rx="1" fill="none" stroke={color} strokeWidth="1.5"/>
    <rect x="13" y="12" width="3" height="9" rx="1" fill="none" stroke={color} strokeWidth="1.5"/>
    <rect x="18" y="6" width="3" height="15" rx="1" fill="none" stroke={color} strokeWidth="1.5"/>
    {/* Circles above bars (stylized like KPI dots) */}
    <circle cx="4.5" cy="13.5" r="1" stroke={color} strokeWidth="1.2" fill="none"/>
    <circle cx="9.5" cy="8" r="1" stroke={color} strokeWidth="1.2" fill="none"/>
    <circle cx="14.5" cy="10" r="1" stroke={color} strokeWidth="1.2" fill="none"/>
    <circle cx="19.5" cy="4" r="1" stroke={color} strokeWidth="1.2" fill="none"/>
  </svg>
);

// Generate daily stock data for smoother animation
const generateDailyStockData = () => {
  const data = [];
  const startDate = new Date('2019-01-01');
  const endDate = new Date('2022-12-31');
  let currentPrice = 85;
  
  const currentDate = new Date(startDate);
  while (currentDate <= endDate) {
    // Add some randomness to the price movement
    const volatility = 0.02;
    const change = (Math.random() - 0.5) * volatility;
    currentPrice = Math.max(10, currentPrice * (1 + change));
    
    // Add some trend and seasonality
    const dayOfYear = Math.floor((currentDate - new Date(currentDate.getFullYear(), 0, 0)) / (1000 * 60 * 60 * 24));
    const trend = 0.0001;
    const seasonal = Math.sin(dayOfYear / 365 * 2 * Math.PI) * 0.0005;
    currentPrice = currentPrice * (1 + trend + seasonal);
    
    data.push({
      date: currentDate.toISOString().split('T')[0],
      price: Math.round(currentPrice * 100) / 100,
      volume: Math.floor(Math.random() * 500000) + 800000,
      netIncome: Math.floor(Math.random() * 1000000) + 4000000,
      assets: Math.floor(Math.random() * 5000000) + 20000000
    });
    
    currentDate.setDate(currentDate.getDate() + 1);
  }
  
  return data;
};

const STOCK_DATA = generateDailyStockData();

// Calculate SPY data (simplified - 7% annual return)
const generateSPYData = () => {
  const spyData = [];
  const startDate = new Date('2019-01-01');
  const endDate = new Date('2022-12-31');
  let spyPrice = 100;
  
  const currentDate = new Date(startDate);
  while (currentDate <= endDate) {
    const dailyReturn = Math.pow(1.07, 1/365) - 1; // 7% annual return converted to daily
    const volatility = (Math.random() - 0.5) * 0.015; // Daily volatility
    spyPrice = spyPrice * (1 + dailyReturn + volatility);
    
    spyData.push({
      date: currentDate.toISOString().split('T')[0],
      price: Math.round(spyPrice * 100) / 100
    });
    
    currentDate.setDate(currentDate.getDate() + 1);
  }
  
  return spyData;
};

const SPY_DATA = generateSPYData();

const NEWS_DATA = [
  {
    date: '2019-02-15',
    headline: 'Company Reports Strong Q4 Earnings',
    body: 'The company exceeded expectations with revenue growth of 15% year-over-year.'
  },
  {
    date: '2019-05-20',
    headline: 'New Product Launch Announced',
    body: 'Management announced the launch of their revolutionary new product line.'
  },
  {
    date: '2019-08-10',
    headline: 'Partnership with Major Tech Company',
    body: 'Strategic partnership expected to drive significant revenue growth.'
  },
  {
    date: '2019-11-05',
    headline: 'Quarterly Dividend Increased',
    body: 'Board approves 10% increase in quarterly dividend payment.'
  },
  {
    date: '2020-01-05',
    headline: 'CEO Resignation Announced',
    body: 'The board announced the CEO will step down at the end of the quarter.'
  },
  {
    date: '2020-04-15',
    headline: 'Record Breaking Quarter',
    body: 'Company posts record revenue and profit margins for Q1 2020.'
  },
  {
    date: '2020-07-22',
    headline: 'Major Acquisition Completed',
    body: 'Strategic acquisition of competitor company finalized.'
  },
  {
    date: '2020-10-30',
    headline: 'New Manufacturing Facility Opens',
    body: 'State-of-the-art facility expected to double production capacity.'
  },
  {
    date: '2021-02-12',
    headline: 'Innovation Award Received',
    body: 'Company recognized for breakthrough technology development.'
  },
  {
    date: '2021-06-18',
    headline: 'International Expansion Plans',
    body: 'Management announces aggressive expansion into European markets.'
  }
];

const FINANCIAL_DATA = {
  '2019-03-31': {
    cashFlow: { operatingCF: 1000000, investingCF: -700000, financingCF: -150000 },
    incomeStatement: { revenue: 4500000, netIncome: 700000, eps: 2.20 },
    balanceSheet: { totalAssets: 22000000, totalLiabilities: 13000000, equity: 9000000 }
  },
  '2019-06-30': {
    cashFlow: { operatingCF: 1100000, investingCF: -750000, financingCF: -125000 },
    incomeStatement: { revenue: 4700000, netIncome: 750000, eps: 2.35 },
    balanceSheet: { totalAssets: 23000000, totalLiabilities: 13300000, equity: 9700000 }
  },
  '2019-09-30': {
    cashFlow: { operatingCF: 1150000, investingCF: -800000, financingCF: -100000 },
    incomeStatement: { revenue: 4900000, netIncome: 780000, eps: 2.44 },
    balanceSheet: { totalAssets: 24000000, totalLiabilities: 13600000, equity: 10400000 }
  },
  '2019-12-31': {
    cashFlow: { operatingCF: 1200000, investingCF: -850000, financingCF: -75000 },
    incomeStatement: { revenue: 5100000, netIncome: 820000, eps: 2.56 },
    balanceSheet: { totalAssets: 25000000, totalLiabilities: 14000000, equity: 11000000 }
  },
  '2020-03-31': {
    cashFlow: { operatingCF: 1200000, investingCF: -800000, financingCF: -200000 },
    incomeStatement: { revenue: 5000000, netIncome: 800000, eps: 2.50 },
    balanceSheet: { totalAssets: 25000000, totalLiabilities: 15000000, equity: 10000000 }
  },
  '2020-06-30': {
    cashFlow: { operatingCF: 1300000, investingCF: -900000, financingCF: -150000 },
    incomeStatement: { revenue: 5200000, netIncome: 850000, eps: 2.65 },
    balanceSheet: { totalAssets: 26000000, totalLiabilities: 15200000, equity: 10800000 }
  },
  '2020-09-30': {
    cashFlow: { operatingCF: 1400000, investingCF: -1000000, financingCF: -100000 },
    incomeStatement: { revenue: 5500000, netIncome: 900000, eps: 2.81 },
    balanceSheet: { totalAssets: 27000000, totalLiabilities: 15500000, equity: 11500000 }
  },
  '2020-12-31': {
    cashFlow: { operatingCF: 1500000, investingCF: -1100000, financingCF: -50000 },
    incomeStatement: { revenue: 5800000, netIncome: 950000, eps: 2.97 },
    balanceSheet: { totalAssets: 28000000, totalLiabilities: 15800000, equity: 12200000 }
  },
  '2021-03-31': {
    cashFlow: { operatingCF: 1600000, investingCF: -1150000, financingCF: -25000 },
    incomeStatement: { revenue: 6000000, netIncome: 1000000, eps: 3.13 },
    balanceSheet: { totalAssets: 29000000, totalLiabilities: 16000000, equity: 13000000 }
  },
  '2021-06-30': {
    cashFlow: { operatingCF: 1700000, investingCF: -1200000, financingCF: 0 },
    incomeStatement: { revenue: 6200000, netIncome: 1050000, eps: 3.28 },
    balanceSheet: { totalAssets: 30000000, totalLiabilities: 16200000, equity: 13800000 }
  },
  '2021-09-30': {
    cashFlow: { operatingCF: 1800000, investingCF: -1250000, financingCF: 25000 },
    incomeStatement: { revenue: 6500000, netIncome: 1100000, eps: 3.44 },
    balanceSheet: { totalAssets: 31000000, totalLiabilities: 16500000, equity: 14500000 }
  },
  '2021-12-31': {
    cashFlow: { operatingCF: 1900000, investingCF: -1300000, financingCF: 50000 },
    incomeStatement: { revenue: 6800000, netIncome: 1150000, eps: 3.59 },
    balanceSheet: { totalAssets: 32000000, totalLiabilities: 16800000, equity: 15200000 }
  }
};

function DelFi() {
  const [currentDate, setCurrentDate] = useState(new Date('2019-01-01'));
  const [simulationDate, setSimulationDate] = useState(new Date('2019-01-01'));
  const [isPlaying, setIsPlaying] = useState(false);
  const [portfolioValue, setPortfolioValue] = useState(100000);
  const [basePortfolioValue, setBasePortfolioValue] = useState(100000);
  const [allocation, setAllocation] = useState(20);
  const [activeTab, setActiveTab] = useState('Data');
  const [pinnedTabs, setPinnedTabs] = useState([]);
  const [isHovered, setIsHovered] = useState(false);
  const [isQuarterEnd, setIsQuarterEnd] = useState(false);
  const [chartTimeframe, setChartTimeframe] = useState('Max');
  const [chartZoom, setChartZoom] = useState(1);
  const [additionalCharts, setAdditionalCharts] = useState([]);
  const timelineButtonsRef = useRef(null);
  const addToChartRef = useRef(null);
  const additionalChartsContainerRef = useRef(null);
  const [chartHeight, setChartHeight] = useState(400);
  const [hoveredPoint, setHoveredPoint] = useState(null);
  const [hoveredNews, setHoveredNews] = useState(null);
  const intervalRef = useRef(null);

  // NEW: Screen navigation state
  const [currentScreen, setCurrentScreen] = useState('Training');

  // NEW: Live mode state
  const [selectedUniverse, setSelectedUniverse] = useState([]);
  const [activeAllocation, setActiveAllocation] = useState([]);
  const [weeklyLeaderboard, setWeeklyLeaderboard] = useState([]);
  const [universeSelectionComplete, setUniverseSelectionComplete] = useState(false);
  const [lastAllocationChangeDate, setLastAllocationChangeDate] = useState(null);
  const [canChangeAllocation, setCanChangeAllocation] = useState(true);

  const { width, dwidth, dheight } = useWindowSize();
  const isMobile = width < 768;
  const isTablet = width >= 768 && width < 1024;

  const isQuarterEndDate = useCallback((date) => {
    const month = date.getMonth();
    const day = date.getDate();
    return (month === 2 && day === 31) || 
           (month === 5 && day === 30) || 
           (month === 8 && day === 30) || 
           (month === 11 && day === 31);
  }, []);

  const getCurrentStockPrice = useCallback(() => {
    const stockEntry = STOCK_DATA
      .filter(entry => new Date(entry.date) <= currentDate)
      .slice(-1)[0];
    return stockEntry ? stockEntry.price : 85;
  }, [currentDate]);

  const getCurrentSPYPrice = useCallback(() => {
    const spyEntry = SPY_DATA
      .filter(entry => new Date(entry.date) <= currentDate)
      .slice(-1)[0];
    return spyEntry ? spyEntry.price : 100;
  }, [currentDate]);

  const getFilteredNews = useCallback(() => {
    return NEWS_DATA.filter(news =>
      new Date(news.date) <= currentDate
    ).sort((a, b) => new Date(b.date) - new Date(a.date));
  }, [currentDate]);

  const getCurrentFinancialData = useCallback(() => {
    const quarters = Object.keys(FINANCIAL_DATA).sort();
    let lastQuarter = null;
    for (let q of quarters) {
      if (new Date(q) <= currentDate) {
        lastQuarter = q;
      }
    }
    return lastQuarter ? FINANCIAL_DATA[lastQuarter] : null;
  }, [currentDate]);

  const calculatePortfolioValue = useCallback(() => {
    const currentStockPrice = getCurrentStockPrice();
    const currentSPYPrice = getCurrentSPYPrice();
    const initialStockPrice = 85;
    const initialSPYPrice = 100;
    
    // During quarter end stops, return the frozen base portfolio value
    // This prevents the displayed value from changing when user adjusts allocation
    if (isQuarterEnd) {
      return basePortfolioValue;
    }
    
    // Convert basis points to percentage (100 bp = 1%)
    const overweightBasisPoints = allocation;
    
    // Base allocation: assume we start with equal weight in S&P 500 (0.2% per stock)
    const baseStockWeight = 1 / 500; // 0.002 = 0.2%
    
    // Calculate the overweight amount in actual percentage terms
    const actualStockWeight = baseStockWeight + (overweightBasisPoints / 10000);
    
    // The remaining weight goes to other S&P 500 stocks
    const spyWeight = 1 - actualStockWeight;
    
    // Calculate returns since the last rebalancing point
    const stockReturn = currentStockPrice / initialStockPrice;
    const spyReturn = currentSPYPrice / initialSPYPrice;
    
    // Calculate portfolio value based on the base value at last rebalancing
    const stockValue = basePortfolioValue * actualStockWeight * stockReturn;
    const spyValue = basePortfolioValue * spyWeight * spyReturn;
    
    return stockValue + spyValue;
  }, [getCurrentStockPrice, getCurrentSPYPrice, allocation, isQuarterEnd, basePortfolioValue]);

  const calculateReturns = useCallback(() => {
    const currentStockPrice = getCurrentStockPrice();
    const currentSPYPrice = getCurrentSPYPrice();
    const initialStockPrice = 85;
    const initialSPYPrice = 100;
    
    const stockReturn = ((currentStockPrice / initialStockPrice) - 1) * 100;
    const spyReturn = ((currentSPYPrice / initialSPYPrice) - 1) * 100;
    
    return { stockReturn, spyReturn };
  }, [getCurrentStockPrice, getCurrentSPYPrice]);

  const handleContinue = useCallback(() => {
    // Update the base portfolio value to the current calculated value before continuing
    // This "locks in" the new allocation for future calculations
    const currentStockPrice = getCurrentStockPrice();
    const currentSPYPrice = getCurrentSPYPrice();
    const initialStockPrice = 85;
    const initialSPYPrice = 100;
    
    const overweightBasisPoints = allocation;
    const baseStockWeight = 1 / 500;
    const actualStockWeight = baseStockWeight + (overweightBasisPoints / 10000);
    const spyWeight = 1 - actualStockWeight;
    
    const stockReturn = currentStockPrice / initialStockPrice;
    const spyReturn = currentSPYPrice / initialSPYPrice;
    
    const newBaseValue = basePortfolioValue * actualStockWeight * stockReturn + basePortfolioValue * spyWeight * spyReturn;
    setBasePortfolioValue(newBaseValue);
    
    setIsQuarterEnd(false);
    setIsPlaying(true);
    setCurrentDate(simulationDate);
  }, [simulationDate, allocation, getCurrentStockPrice, getCurrentSPYPrice, basePortfolioValue]);

  const togglePin = useCallback((tab) => {
    setPinnedTabs(prev =>
      prev.includes(tab)
        ? prev.filter(t => t !== tab)
        : [...prev, tab]
    );
  }, []);

  const handleSliderChange = useCallback((value) => {
    if (isPlaying && !isQuarterEnd) return; // Don't allow forward scrubbing during play
    
    const daysDiff = parseInt(value);
    const newDate = new Date('2019-01-01');
    newDate.setDate(newDate.getDate() + daysDiff);
    
    // Don't allow going past simulation date
    if (newDate <= simulationDate || isQuarterEnd) {
      setCurrentDate(newDate);
    }
  }, [simulationDate, isPlaying, isQuarterEnd]);

  const toggleAdditionalChart = useCallback((chartType) => {
    setAdditionalCharts(prev => 
      prev.includes(chartType)
        ? prev.filter(type => type !== chartType)
        : [...prev, chartType]
    );
  }, []);

  const calculateChartHeight = useCallback(() => {
    // Get available space from parent container
    const containerHeight = dheight - 80; // Subtract title section
    const topSectionRatio = isMobile ? 0.6 : 0.667;
    const availableHeight = containerHeight * topSectionRatio;
    
    // Account for chart panel padding and other elements
    let usedHeight = 36; // Base padding
    
    // Chart header height (title + timeframe buttons)
    if (timelineButtonsRef.current) {
      usedHeight += timelineButtonsRef.current.offsetHeight + 26; // +26 for margins/padding
    } else {
      usedHeight += 60; // Estimated header height
    }
    
    // Add to Chart controls height
    if (addToChartRef.current) {
      usedHeight += addToChartRef.current.offsetHeight + 16;
    } else {
      usedHeight += 50; // Estimated controls height
    }
    
    // Buffer space
    usedHeight += 20;
    
    const calculatedHeight = Math.max(300, availableHeight - usedHeight);
    return calculatedHeight;
  }, [dheight, isMobile, additionalCharts]);

  const getTimeframeData = useCallback((timeframe) => {
    const now = currentDate;
    let startDate = new Date('2019-01-01');
    
    switch(timeframe) {
      case '5D':
        startDate = new Date(now);
        startDate.setDate(startDate.getDate() - 5);
        break;
      case '1M':
        startDate = new Date(now);
        startDate.setMonth(startDate.getMonth() - 1);
        break;
      case '3M':
        startDate = new Date(now);
        startDate.setMonth(startDate.getMonth() - 3);
        break;
      case '6M':
        startDate = new Date(now);
        startDate.setMonth(startDate.getMonth() - 6);
        break;
      case '1Y':
        startDate = new Date(now);
        startDate.setFullYear(startDate.getFullYear() - 1);
        break;
      case '3Y':
        startDate = new Date(now);
        startDate.setFullYear(startDate.getFullYear() - 3);
        break;
      case '5Y':
        startDate = new Date(now);
        startDate.setFullYear(startDate.getFullYear() - 5);
        break;
      case 'Max':
      default:
        startDate = new Date('2019-01-01');
        break;
    }
    
    return STOCK_DATA.filter(item => {
      const itemDate = new Date(item.date);
      return itemDate >= startDate && itemDate <= now;
    });
  }, [currentDate]);

  useEffect(() => {
    if (isPlaying) {
      intervalRef.current = setInterval(() => {
        setSimulationDate(prev => {
          const next = new Date(prev);
          next.setDate(next.getDate() + 1);

          if (isQuarterEndDate(next)) {
            setIsPlaying(false);
            setIsQuarterEnd(true);
          }

          return next;
        });
        setCurrentDate(prev => {
          const next = new Date(prev);
          next.setDate(next.getDate() + 1);
          return next;
        });
      }, 100);
    } else {
      clearInterval(intervalRef.current);
    }

    return () => clearInterval(intervalRef.current);
  }, [isPlaying, isQuarterEndDate]);

  useEffect(() => {
    setPortfolioValue(calculatePortfolioValue());
  }, [calculatePortfolioValue]);

  // Update chart height
  useEffect(() => {
    const updateHeight = () => {
      // Add small delay to ensure DOM measurements are accurate
      requestAnimationFrame(() => {
        const newHeight = calculateChartHeight();
        setChartHeight(newHeight);
      });
    };
    
    // Initial calculation
    updateHeight();
    
    // Update on window resize with debounce
    let resizeTimeout;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updateHeight, 50); // Faster debounce
    };
    
    window.addEventListener('resize', handleResize);
    
    // More comprehensive ResizeObserver
    const resizeObserver = new ResizeObserver(entries => {
      // Only update if size actually changed significantly
      let shouldUpdate = false;
      for (let entry of entries) {
        if (entry.contentRect.height > 0) {
          shouldUpdate = true;
          break;
        }
      }
      if (shouldUpdate) {
        updateHeight();
      }
    });
    
    // Observe multiple elements
    if (timelineButtonsRef.current) {
      resizeObserver.observe(timelineButtonsRef.current);
    }
    if (addToChartRef.current) {
      resizeObserver.observe(addToChartRef.current);
    }
    
    return () => {
      window.removeEventListener('resize', handleResize);
      resizeObserver.disconnect();
      clearTimeout(resizeTimeout);
    };
  }, [calculateChartHeight]);

  // Start at first quarter end instead of showing initial dialog
  useEffect(() => {
    const firstQuarterEnd = new Date('2019-03-31');
    setCurrentDate(firstQuarterEnd);
    setSimulationDate(firstQuarterEnd);
    setIsQuarterEnd(true);
  }, []);

  const topSectionHeight = isMobile ? '60vh' : '66.67vh';
  const bottomSectionHeight = isMobile ? '40vh' : '33.33vh';
  const leftPanelWidth = isMobile ? '100%' : isTablet ? '55%' : '66.67%';
  const chartPanelWidth = isMobile ? '100%' : isTablet ? '45%' : '33.33%';

  const currentDays = Math.floor((currentDate - new Date('2019-01-01')) / (1000 * 60 * 60 * 24));
  const maxAllowedDays = Math.floor((simulationDate - new Date('2019-01-01')) / (1000 * 60 * 60 * 24));

  const { stockReturn, spyReturn } = calculateReturns();

  return (
    <div 
      className="delfi-app"
      style={{
        width: dwidth,
        height: dheight,
        position: 'fixed',
        top: 'env(safe-area-inset-top, 0px)',
        left: 'env(safe-area-inset-left, 0px)',
        right: 'env(safe-area-inset-right, 0px)',
        bottom: 'env(safe-area-inset-bottom, 0px)'
      }}
    >
      {/* Title Section */}
      <div className="title-section" style={{
        height: '120px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #1a1a2e, #16213e)',
        borderBottom: '2px solid #333',
        boxShadow: '0 2px 10px rgba(0,0,0,0.3)'
      }}>
        <h1 style={{
          fontSize: isMobile ? '2.5em' : '3.5em',
          fontWeight: 'bold',
          color: '#00ff88',
          textShadow: '0 0 20px rgba(0,255,136,0.5)',
          margin: '0 0 10px 0',
          letterSpacing: '2px'
        }}>DelFi</h1>
        
        <div style={{ display: 'flex', gap: '10px' }}>
          <button onClick={() => setCurrentScreen('Training')} style={{
            padding: '8px 24px',
            fontSize: '1.1em',
            fontWeight: 600,
            background: currentScreen === 'Training' ? '#00ff88' : 'transparent',
            color: currentScreen === 'Training' ? '#1a1a2e' : '#00ff88',
            border: '2px solid #00ff88',
            borderRadius: '8px',
            cursor: 'pointer',
            transition: 'all 0.3s ease'
          }}>Training</button>
          
          <button onClick={() => setCurrentScreen('Live')} style={{
            padding: '8px 24px',
            fontSize: '1.1em',
            fontWeight: 600,
            background: currentScreen === 'Live' ? '#00ff88' : 'transparent',
            color: currentScreen === 'Live' ? '#1a1a2e' : '#00ff88',
            border: '2px solid #00ff88',
            borderRadius: '8px',
            cursor: 'pointer',
            transition: 'all 0.3s ease'
          }}>Live</button>
          
          <button onClick={() => setCurrentScreen('Trading')} style={{
            padding: '8px 24px',
            fontSize: '1.1em',
            fontWeight: 600,
            background: currentScreen === 'Trading' ? '#00ff88' : 'transparent',
            color: currentScreen === 'Trading' ? '#1a1a2e' : '#00ff88',
            border: '2px solid #00ff88',
            borderRadius: '8px',
            cursor: 'pointer',
            transition: 'all 0.3s ease'
          }}>Trading</button>
        </div>
      </div>

    {currentScreen === 'Training' ? (
      <div style={{ height: 'calc(100% - 120px)' }}>
        {/* Main Content Container */}
        <div style={{
          height: `calc(100% - 80px)`,
          display: 'flex',
          flexDirection: 'column'
        }}>
          {/* Top Section */}
          <div
            className="top-section"
            style={{
              flex: isMobile ? '3' : '2', // 60% = 3/5, 66.67% = 2/3
              display: 'flex',
              height: topSectionHeight,
              borderBottom: '1px solid #333',
              color: '#ffffff',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              flexDirection: isMobile ? 'column' : 'row'
            }}
          >
            
            {/* Company Data Container - styled to match your chart panel */}
            <div
              className="left-panel"
              style={{
                background: '#191a1e',           // match your chart panel
                borderRadius: '16px',
                border: '1.5px solid #27274a',   // match border on chart panel
                boxShadow: '0 2px 16px 0 rgba(0,0,0,.10)',
                width: leftPanelWidth,
                height: isMobile ? '50%' : '100%',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden'
              }}
            >
              <div
                className="chart-header"
                style={{
                  flexDirection: isMobile ? 'column' : 'row',
                  alignItems: isMobile ? 'flex-start' : 'center',
                  gap: '8px',
                  padding: '18px',
                  borderBottom: '1.5px solid #232342',
                  background: 'transparent'
                }}
              >
                <h3 style={{
                  fontSize: isMobile ? '1.2em' : '1.4em',
                  fontWeight: 700,
                  color: "#fff",
                  letterSpacing: 0.2,
                  margin: 0
                }}>
                  Company Data
                </h3>
              </div>

              <div style={{
                display: "flex",
                flex: 1,
                minHeight: 0
              }}>
                {/* Sidebar */}
                <div
                  style={{
                    width: '200px',
                    borderRight: '1px solid #232342',
                    background: 'transparent',
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '18px 0',
                    minHeight: 0
                  }}
                >
                  <ul style={{
                    listStyle: "none",
                    margin: 0,
                    padding: 0,
                    width: "100%"
                  }}>
                    {[
                      { key: 'Data', icon: <DataIcon size={28} />, label: 'Data' },
                      { key: 'News', icon: <NewsIcon size={28} />, label: 'News' },
                      { key: 'Analytics', icon: <AnalyticsIcon size={28} />, label: 'Analytics' }
                    ].map(item => (
                      <li key={item.key}
                        onClick={() => setActiveTab(item.key)}
                        style={{
                          cursor: 'pointer',
                          padding: '18px 24px',
                          display: "flex",
                          alignItems: "center",
                          borderRadius: '8px',
                          marginBottom: '8px',
                          background: activeTab === item.key ? "#212145" : "none",
                          color: activeTab === item.key ? "#00ff88" : "#ccc",
                          transition: "background 0.15s, color 0.15s"
                        }}
                        onMouseEnter={e => { e.currentTarget.style.background = "#1e1e34"; }}
                        onMouseLeave={e => { e.currentTarget.style.background = activeTab === item.key ? "#212145" : "none"; }}
                      >
                        <span style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: 32,
                          height: 32
                        }}>{item.icon}</span>
                        <span style={{
                          marginLeft: "16px",
                          fontSize: "1.13em",
                          fontWeight: 500,
                          flex: 1
                        }}>
                          {item.label}
                        </span>
                        <span
                          title={pinnedTabs.includes(item.key) ? "Unpin" : "Pin"}
                          onClick={e => {
                            e.stopPropagation();
                            togglePin(item.key);
                            setActiveTab(item.key);
                          }}
                          style={{
                            marginLeft: 12,
                            cursor: "pointer",
                            fontSize: "1em",
                            opacity: isHovered ? 1 : 0.7,
                            transition: "opacity 0.2s ease",
                            minWidth: 24,
                            minHeight: 24,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                          }}
                          onMouseEnter={() => setIsHovered(true)}
                          onMouseLeave={() => setIsHovered(false)}
                          onFocus={() => setIsHovered(true)}
                          onBlur={() => setIsHovered(false)}
                        >
                          {pinnedTabs.includes(item.key) ? "📍" : "📌"}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
                {/* Workspace & Pinned Tabs */}
                <div style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "row",
                  minHeight: 0
                }}>
                  {/* Pinned Tabs */}
                  {pinnedTabs.map((tab, idx) => (
                    <div 
                      key={tab}
                      style={{
                        width: pinnedTabs.length === 3 ? `${100 / 3}%` : `${100 / (pinnedTabs.length + 1)}%`,
                        borderRight: '1px solid #232342',
                        position: 'relative',
                        background: 'none'
                      }}
                    >
                      <div style={{
                        padding: '10px 16px',
                        borderBottom: '1px solid #232342',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                      }}>
                        <span style={{ 
                          fontSize: isMobile ? '1.02rem' : '1.09rem',
                          color: '#00ff88',
                          fontWeight: 600
                        }}>{tab}</span>
                        <button 
                          onClick={() => togglePin(tab)} 
                          style={{
                            background: 'none',
                            border: 'none',
                            color: '#ff6b6b',
                            cursor: 'pointer',
                            fontSize: '1.28em',
                            padding: '0 5px'
                          }}
                        >×</button>
                      </div>
                      <div style={{ padding: '16px', height: 'calc(100% - 52px)', overflow: 'auto' }}>
                        {tab === 'Data' && <DataTab data={getCurrentFinancialData()} isMobile={isMobile} />}
                        {tab === 'News' && <NewsTab news={getFilteredNews()} isMobile={isMobile} />}
                        {tab === 'Analytics' && <AnalyticsTab stockPrice={getCurrentStockPrice()} isMobile={isMobile} />}
                      </div>
                    </div>
                  ))}
                  {/* Main Workspace */}
                  {pinnedTabs.length < 3 && (
                    <div 
                      style={{
                        width: `${100 / (pinnedTabs.length + 1)}%`,
                        padding: '16px',
                        overflow: 'auto',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      {pinnedTabs.length === 0 || !pinnedTabs.includes(activeTab) ? (
                        <>
                          {activeTab === 'Data' && <DataTab data={getCurrentFinancialData()} isMobile={isMobile} />}
                          {activeTab === 'News' && <NewsTab news={getFilteredNews()} isMobile={isMobile} />}
                          {activeTab === 'Analytics' && <AnalyticsTab stockPrice={getCurrentStockPrice()} isMobile={isMobile} />}
                        </>
                      ) : (
                        <div style={{
                          color: '#666',
                          fontSize: isMobile ? '1.01rem' : '1.09rem',
                          textAlign: 'center',
                          padding: '22px'
                        }}>
                          Add a section using the menu on the left
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Right Side - Stock Chart */}
            <div
              className="chart-panel"
              style={{
                flex: 1,
                background: '#191a1e',
                minWidth: 0,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 16,
                padding: 18,
                color: '#ffffff',
                width: chartPanelWidth,
                height: isMobile ? '50%' : '100%'
              }}
            >
              <StockChart
                data={getTimeframeData(chartTimeframe)}
                allData={STOCK_DATA}
                newsData={NEWS_DATA}
                currentDate={currentDate}
                timeframe={chartTimeframe}
                setTimeframe={setChartTimeframe}
                zoom={chartZoom}
                setZoom={setChartZoom}
                additionalCharts={additionalCharts}
                toggleAdditionalChart={toggleAdditionalChart}
                chartHeight={chartHeight}
                timelineButtonsRef={timelineButtonsRef}
                addToChartRef={addToChartRef}
                additionalChartsContainerRef={additionalChartsContainerRef}
                isMobile={isMobile}
                hoveredPoint={hoveredPoint}
                setHoveredPoint={setHoveredPoint}
                hoveredNews={hoveredNews}
                setHoveredNews={setHoveredNews}
              />
            </div>
          </div>

          {/* Bottom Section */}
          <div
            className="bottom-section"
            style={{
              flex: isMobile ? '2' : '1', // 40% = 2/5, 33.33% = 1/3
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              height: bottomSectionHeight,
              background: '#18191a',
              padding: isMobile ? 12 : 18,
              color: '#ffffff',
              borderTop: '1px solid #333'
            }}
          >
            <div
              className="timeline-container"
              style={{
                flex: isMobile ? 1 : 3,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'flex-start',
                padding: '14px 0',
                color: '#ffffff',
                marginBottom: isMobile ? 16 : 0
              }}
            >
              <div
                className="current-date"
                style={{
                  fontSize: isMobile ? '1.1em' : '1.2em',
                  textAlign: 'center',
                  marginBottom: 16,
                  color: '#ffffff',
                  letterSpacing: 0.5,
                  fontWeight: 500
                }}
              >
                {currentDate.toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: isMobile ? 'short' : 'long',
                  day: 'numeric'
                })}
              </div>
              <div
                className="timeline-slider"
                style={{
                  position: 'relative',
                  width: '90%',
                  padding: '14px 0 0 0'
                }}
              >
                <input
                  type="range"
                  min="0"
                  max={maxAllowedDays}
                  value={currentDays}
                  onChange={(e) => handleSliderChange(e.target.value)}
                  className="slider"
                  style={{
                    width: '100%',
                    appearance: 'none',
                    WebkitAppearance: 'none',
                    height: isMobile ? 8 : 6,
                    background: 'linear-gradient(90deg, #1fd887 0%, #064531 100%)',
                    borderRadius: 8,
                    outline: 'none',
                    transition: 'all 0.2s ease'
                  }}
                />
              </div>
            </div>

            <div
              className="portfolio-controls"
              style={{
                flex: isMobile ? undefined : 2,
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                justifyContent: isMobile ? 'space-between' : 'space-evenly',
                alignItems: isMobile ? 'center' : 'flex-start',
                gap: isMobile ? 12 : 0
              }}
            >
              <div 
                className="portfolio-value"
                style={{
                  color: '#ffffff',
                  textAlign: 'center'
                }}
              >
                <h3 style={{
                  color: '#ffffff',
                  marginBottom: 8,
                  fontSize: isMobile ? '1em' : '1.1em'
                }}>Portfolio Value</h3>
                <div
                  className="value"
                  style={{
                    fontSize: isMobile ? '1.4em' : '1.8em',
                    fontWeight: 700,
                    color: '#00ff88',
                    letterSpacing: 0.5,
                    textShadow: '0 0 10px rgba(0,255,136,0.3)',
                    margin: '0 0 8px 0'
                  }}>
                  ${portfolioValue.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}
                </div>
                <div style={{
                  fontSize: isMobile ? '0.8em' : '0.9em',
                  color: '#999',
                  textAlign: 'center'
                }}>
                  <div>S&P 500: {spyReturn >= 0 ? '+' : ''}{spyReturn.toFixed(1)}%</div>
                  <div>Stock: {stockReturn >= 0 ? '+' : ''}{stockReturn.toFixed(1)}%</div>
                </div>
              </div>
              
              <div
                className="allocation-control"
                style={{
                  color: '#ffffff',
                  textAlign: 'center'
                }}
              >
                <h3 style={{
                  color: '#ffffff',
                  marginBottom: 8,
                  fontSize: isMobile ? '1em' : '1.1em'
                }}>Stock Allocation</h3>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', justifyContent: 'center' }}>
                    <input
                      type="number"
                      value={allocation}
                      onChange={(e) => setAllocation(Number(e.target.value))}
                      disabled={!isQuarterEnd}
                      step="10"
                      className="allocation-input"
                      style={{
                        width: isMobile ? 80 : 100,
                        fontSize: isMobile ? '1.1em' : '1.2em',
                        border: '1px solid #444',
                        padding: '8px 12px',
                        borderRadius: 8,
                        marginRight: 10,
                        background: '#242424',
                        color: '#ffffff',
                        transition: 'all 0.2s ease',
                        minHeight: 44
                      }}
                    />
                    <span style={{
                      fontSize: isMobile ? '0.9em' : '1em',
                      marginLeft: 4,
                      color: '#ffffff'
                    }}>basis points</span>
                  </div>
                  <div style={{
                    fontSize: isMobile ? '0.75em' : '0.8em',
                    color: '#999',
                    fontStyle: 'italic',
                    marginTop: 4,
                    textAlign: 'center'
                  }}>
                    20 bps baseline (1/500)
                  </div>
                </div>
              </div>

              {isQuarterEnd && (
                <button
                  onClick={handleContinue}
                  className="continue-btn"
                  style={{
                    fontSize: isMobile ? '1.1em' : '1.3em',
                    fontWeight: 'bold',
                    padding: isMobile ? '8px 20px' : '12px 28px',
                    marginTop: isMobile ? 8 : 22,
                    background: 'linear-gradient(90deg, #1fd887 65%, #27ce93 100%)',
                    color: '#191a1e',
                    border: 'none',
                    borderRadius: 14,
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    cursor: 'pointer',
                    minHeight: 48,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 4px 12px rgba(31, 216, 135, 0.3)'
                  }}
                >
                  Continue
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    ) : currentScreen === 'Live' ? (
      <LiveScreen 
        selectedUniverse={selectedUniverse}
        setSelectedUniverse={setSelectedUniverse}
        activeAllocation={activeAllocation}
        setActiveAllocation={setActiveAllocation}
        handleUniverseSelection={(stocks) => {
          if (stocks.length === 15) {
            setSelectedUniverse(stocks);
            const equalWeight = 100 / 15;
            setActiveAllocation(stocks.map(stock => ({
              ticker: stock,
              weight: equalWeight
            })));
            setUniverseSelectionComplete(true);
          }
        }}
        universeSelectionComplete={universeSelectionComplete}
        canChangeAllocation={canChangeAllocation}
        weeklyLeaderboard={weeklyLeaderboard}
        isMobile={isMobile}
        dwidth={dwidth}
        dheight={dheight}
      />
    ) : (
      <TradingScreen
        isMobile={isMobile}
        dwidth={dwidth}
        dheight={dheight}
      />
    )}
    </div>
  );
}

function DataTab({ data, isMobile }) {
  if (!data) return <div>No financial data available</div>;
  return (
    <div style={{ width: '100%', color: '#ffffff' }}>
      {['cashFlow', 'incomeStatement', 'balanceSheet'].map((section, i) => (
        <div
          key={section}
          className="financial-section"
          style={{
            fontSize: isMobile ? '0.9em' : '1em',
            padding: isMobile ? '10px 12px' : '12px 16px',
            marginBottom: '1.6em',
            background: '#1b1c1e',
            borderRadius: 8,
            color: '#ffffff',
            border: '1px solid #2a2a2a',
            transition: 'all 0.2s ease'
          }}
        >
          <h4 style={{
            color: '#ffffff',
            marginBottom: 8,
            fontSize: isMobile ? '1em' : '1.1em',
            borderBottom: '1px solid #333',
            paddingBottom: 4
          }}>
            {section === 'cashFlow' ? 'Cash Flow'
              : section === 'incomeStatement' ? 'Income Statement'
              : 'Balance Sheet'}
          </h4>
          {section === 'cashFlow' && (
            <>
              <div style={{ color: '#ffffff', marginBottom: 4, padding: '2px 0' }}>Operating CF: ${data.cashFlow.operatingCF.toLocaleString()}</div>
              <div style={{ color: '#ffffff', marginBottom: 4, padding: '2px 0' }}>Investing CF: ${data.cashFlow.investingCF.toLocaleString()}</div>
              <div style={{ color: '#ffffff', marginBottom: 4, padding: '2px 0' }}>Financing CF: ${data.cashFlow.financingCF.toLocaleString()}</div>
            </>
          )}
          {section === 'incomeStatement' && (
            <>
              <div style={{ color: '#ffffff', marginBottom: 4, padding: '2px 0' }}>Revenue: ${data.incomeStatement.revenue.toLocaleString()}</div>
              <div style={{ color: '#ffffff', marginBottom: 4, padding: '2px 0' }}>Net Income: ${data.incomeStatement.netIncome.toLocaleString()}</div>
              <div style={{ color: '#ffffff', marginBottom: 4, padding: '2px 0' }}>EPS: ${data.incomeStatement.eps}</div>
            </>
          )}
          {section === 'balanceSheet' && (
            <>
              <div style={{ color: '#ffffff', marginBottom: 4, padding: '2px 0' }}>Total Assets: ${data.balanceSheet.totalAssets.toLocaleString()}</div>
              <div style={{ color: '#ffffff', marginBottom: 4, padding: '2px 0' }}>Total Liabilities: ${data.balanceSheet.totalLiabilities.toLocaleString()}</div>
              <div style={{ color: '#ffffff', marginBottom: 4, padding: '2px 0' }}>Equity: ${data.balanceSheet.equity.toLocaleString()}</div>
            </>
          )}
        </div>
      ))}
    </div>
  );
}

function NewsTab({ news, isMobile }) {
  return (
    <div style={{ width: '100%', color: '#ffffff' }}>
      {news.length === 0 ? (
        <div>No news available yet.</div>
      ) : (
        news.map((article, index) => (
          <div
            key={index}
            className="news-article"
            style={{
              padding: isMobile ? '10px 12px' : '12px 16px',
              marginBottom: isMobile ? '1em' : '1.2em',
              color: '#ffffff',
              border: '1px solid #2a2a2a',
              background: '#212223',
              borderRadius: 8,
              transition: 'all 0.2s ease'
            }}
          >
            <div
              style={{
                fontSize: isMobile ? '0.85em' : '0.9em',
                color: '#76f9a0',
                marginBottom: 6,
                fontWeight: 500
              }}
            >
              {new Date(article.date).toLocaleDateString()}
            </div>
            <h4 style={{
              color: '#ffffff',
              marginBottom: 8,
              fontSize: isMobile ? '1em' : '1.1em',
              lineHeight: 1.3
            }}>{article.headline}</h4>
            <p style={{
              color: '#ffffff',
              lineHeight: 1.4,
              opacity: 0.9,
              fontSize: isMobile ? '0.9em' : '1em'
            }}>{article.body}</p>
          </div>
        ))
      )}
    </div>
  );
}

function AnalyticsTab({ stockPrice, isMobile }) {
  return (
    <div style={{ width: '100%', color: '#ffffff' }}>
      {[
        { label: "Current Price", value: `$${stockPrice}` },
        { label: "PE Ratio", value: "15.2" },
        { label: "Market Cap", value: "$2.5B" },
        { label: "52W High", value: "$175" },
        { label: "52W Low", value: "$95" }
      ].map((metric, idx) => (
        <div
          key={metric.label}
          className="metric"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: isMobile ? '8px 0' : '10px 0',
            borderBottom: idx !== 4 ? '1px solid #333' : 'none',
            fontSize: isMobile ? '1em' : '1.1em',
            color: '#ffffff',
            transition: 'all 0.2s ease'
          }}
        >
          <span>{metric.label}</span>
          <span>{metric.value}</span>
        </div>
      ))}
    </div>
  );
}

function LiveScreen({
  selectedUniverse,
  setSelectedUniverse,
  activeAllocation,
  setActiveAllocation,
  handleUniverseSelection,
  universeSelectionComplete,
  canChangeAllocation,
  weeklyLeaderboard,
  isMobile,
  dwidth,
  dheight
}) {
  const [step, setStep] = useState('selectUniverse'); // 'selectUniverse' or 'portfolio'
  const [availableStocks] = useState([
    'AAPL', 'MSFT', 'GOOGL', 'AMZN', 'NVDA', 'TSLA', 'META', 'AVGO',
    'ASML', 'NFLX', 'COST', 'AMD', 'PYPL', 'ADBE', 'CRM'
  ]);
  const [selectedStocks, setSelectedStocks] = useState([]);
  const [portfolioValue, setPortfolioValue] = useState(100000);
  const [weeklyReturns, setWeeklyReturns] = useState(0);

  const toggleStockSelection = (stock) => {
    setSelectedStocks(prev => {
      if (prev.includes(stock)) {
        return prev.filter(s => s !== stock);
      } else if (prev.length < 15) {
        return [...prev, stock];
      }
      return prev;
    });
  };

  const handleConfirmSelection = () => {
    if (selectedStocks.length === 15) {
      handleUniverseSelection(selectedStocks);
      setStep('portfolio');
    }
  };

  const handleAllocationChange = (ticker, newWeight) => {
    const updatedAllocation = activeAllocation.map(item =>
      item.ticker === ticker ? { ...item, weight: Math.max(0, newWeight) } : item
    );
    
    if (updatedAllocation.some(item => item.weight > 0)) {
      const normalized = normalizeAllocations(updatedAllocation);
      setActiveAllocation(normalized);
    }
  };

  // Calculate portfolio metrics whenever allocation changes
  useEffect(() => {
    if (activeAllocation.length > 0) {
      // Generate mock stock prices (in a real app, these would come from live data)
      const mockPrices = activeAllocation.map(() => 100 + (Math.random() - 0.5) * 20);
      const metrics = calculatePortfolioMetrics(activeAllocation, mockPrices, portfolioValue);
      setPortfolioValue(metrics.value);
      setWeeklyReturns(metrics.return);
    }
  }, [activeAllocation]);

  if (!universeSelectionComplete) {
    return (
      <div style={{
        height: 'calc(100% - 120px)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#18191a',
        padding: '40px 20px',
        color: '#ffffff'
      }}>
        <h2 style={{
          fontSize: isMobile ? '1.8em' : '2.4em',
          marginBottom: '30px',
          color: '#00ff88',
          textAlign: 'center'
        }}>Select Your Universe</h2>
        
        <p style={{
          fontSize: isMobile ? '1em' : '1.1em',
          marginBottom: '30px',
          color: '#ccc',
          textAlign: 'center',
          maxWidth: '600px'
        }}>
          Choose 15 stocks from the available options to create your portfolio universe
        </p>

        <div style={{
          display: 'grid',
          gridTemplateColumns: isMobile ? 'repeat(3, 1fr)' : 'repeat(5, 1fr)',
          gap: '12px',
          marginBottom: '30px',
          maxWidth: '800px'
        }}>
          {availableStocks.map(stock => (
            <button
              key={stock}
              onClick={() => toggleStockSelection(stock)}
              style={{
                padding: '12px 16px',
                fontSize: isMobile ? '0.9em' : '1em',
                fontWeight: 600,
                background: selectedStocks.includes(stock) ? '#00ff88' : '#222326',
                color: selectedStocks.includes(stock) ? '#1a1a2e' : '#ffffff',
                border: selectedStocks.includes(stock) ? '2px solid #00ff88' : '2px solid #444',
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                minHeight: '44px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              {stock}
            </button>
          ))}
        </div>

        <div style={{
          fontSize: '1.2em',
          marginBottom: '20px',
          color: selectedStocks.length === 15 ? '#00ff88' : '#ff6b6b'
        }}>
          Selected: {selectedStocks.length}/15
        </div>

        <button
          onClick={handleConfirmSelection}
          disabled={selectedStocks.length !== 15}
          style={{
            padding: '12px 40px',
            fontSize: '1.2em',
            fontWeight: 'bold',
            background: selectedStocks.length === 15 
              ? 'linear-gradient(90deg, #1fd887 65%, #27ce93 100%)'
              : '#444',
            color: selectedStocks.length === 15 ? '#191a1e' : '#999',
            border: 'none',
            borderRadius: '8px',
            cursor: selectedStocks.length === 15 ? 'pointer' : 'not-allowed',
            transition: 'all 0.3s ease',
            minHeight: '48px',
            boxShadow: selectedStocks.length === 15 
              ? '0 4px 12px rgba(31, 216, 135, 0.3)'
              : 'none'
          }}
        >
          Confirm Selection
        </button>
      </div>
    );
  }

  return (
    <div style={{
      height: 'calc(100% - 120px)',
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row',
      background: '#18191a',
      color: '#ffffff',
      overflow: 'hidden'
    }}>
      {/* Left Panel - Portfolio & Allocations */}
      <div style={{
        flex: isMobile ? 'none' : 1,
        width: isMobile ? '100%' : 'auto',
        height: isMobile ? '50%' : '100%',
        borderRight: isMobile ? 'none' : '1px solid #333',
        borderBottom: isMobile ? '1px solid #333' : 'none',
        padding: '20px',
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <h2 style={{
          fontSize: '1.8em',
          marginBottom: '20px',
          color: '#00ff88'
        }}>Portfolio</h2>

        <div style={{
          background: '#1b1c1e',
          padding: '16px',
          borderRadius: '8px',
          marginBottom: '20px',
          border: '1px solid #2a2a2a'
        }}>
          <div style={{ color: '#ccc', marginBottom: '8px' }}>Portfolio Value</div>
          <div style={{
            fontSize: '2em',
            fontWeight: 'bold',
            color: '#00ff88',
            marginBottom: '8px'
          }}>
            ${portfolioValue.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}
          </div>
          <div style={{ color: '#999', fontSize: '0.9em' }}>
            Weekly Return: {weeklyReturns >= 0 ? '+' : ''}{weeklyReturns.toFixed(2)}%
          </div>
        </div>

        <h3 style={{
          fontSize: '1.3em',
          marginBottom: '12px',
          color: '#ffffff'
        }}>Allocations</h3>

        <div style={{
          flex: 1,
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
          gap: '12px'
        }}>
          {activeAllocation.map(item => (
            <div
              key={item.ticker}
              style={{
                background: '#1b1c1e',
                padding: '12px',
                borderRadius: '8px',
                border: '1px solid #2a2a2a'
              }}
            >
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: '8px'
              }}>
                <span style={{ fontWeight: 600 }}>{item.ticker}</span>
                <span style={{ color: '#00ff88' }}>{item.weight.toFixed(1)}%</span>
              </div>
              <input
                type="range"
                min="0"
                max="100"
                value={item.weight}
                onChange={(e) => handleAllocationChange(item.ticker, parseFloat(e.target.value))}
                disabled={!canChangeAllocation}
                style={{
                  width: '100%',
                  cursor: canChangeAllocation ? 'pointer' : 'not-allowed',
                  opacity: canChangeAllocation ? 1 : 0.5
                }}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Right Panel - Leaderboard & Stats */}
      <div style={{
        flex: isMobile ? 'none' : 1,
        width: isMobile ? '100%' : 'auto',
        height: isMobile ? '50%' : '100%',
        padding: '20px',
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <h2 style={{
          fontSize: '1.8em',
          marginBottom: '20px',
          color: '#00ff88'
        }}>Weekly Leaderboard</h2>

        {activeAllocation && activeAllocation.length > 0 ? (
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            flex: 1
          }}>
            {/* Mock leaderboard - in production this would come from a backend */}
            {[
              { username: 'You', return: weeklyReturns, value: portfolioValue },
              { username: 'Top Trader', return: weeklyReturns + 2.5, value: portfolioValue * 1.025 },
              { username: 'Growth Investor', return: weeklyReturns - 1.2, value: portfolioValue * 0.988 },
              { username: 'Tech Bull', return: weeklyReturns + 5.3, value: portfolioValue * 1.053 },
              { username: 'Value Hunter', return: weeklyReturns + 0.8, value: portfolioValue * 1.008 }
            ].sort((a, b) => b.return - a.return).map((entry, idx) => (
              <div
                key={idx}
                style={{
                  background: '#1b1c1e',
                  padding: '12px',
                  borderRadius: '8px',
                  border: '1px solid #2a2a2a',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <div>
                  <div style={{ fontWeight: 600, marginBottom: '4px' }}>#{idx + 1}</div>
                  <div style={{ fontSize: '0.9em', color: '#ccc' }}>{entry.username || `User ${idx + 1}`}</div>
                </div>
                <div style={{
                  textAlign: 'right'
                }}>
                  <div style={{
                    fontWeight: 'bold',
                    color: entry.return >= 0 ? '#00ff88' : '#ff6b6b'
                  }}>
                    {entry.return >= 0 ? '+' : ''}{entry.return.toFixed(2)}%
                  </div>
                  <div style={{ fontSize: '0.85em', color: '#999' }}>
                    ${(entry.value || 0).toLocaleString()}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flex: 1,
            color: '#999'
          }}>
            No leaderboard data available yet
          </div>
        )}
      </div>
    </div>
  );
}

// Live mode calculations
function calculatePortfolioMetrics(allocation, stockPrices, baseValue = 100000) {
  let totalValue = 0;
  
  allocation.forEach((item, idx) => {
    const weight = item.weight / 100;
    const value = baseValue * weight;
    const stockValue = value * (stockPrices[idx] / 100); // Assuming initial price of 100
    totalValue += stockValue;
  });
  
  return {
    value: totalValue,
    return: ((totalValue - baseValue) / baseValue) * 100
  };
}

function normalizeAllocations(allocations) {
  const total = allocations.reduce((sum, item) => sum + item.weight, 0);
  return allocations.map(item => ({
    ...item,
    weight: (item.weight / total) * 100
  }));
}

function StockChart({ 
  data, 
  allData,
  newsData, 
  currentDate, 
  timeframe, 
  setTimeframe, 
  zoom, 
  setZoom,
  additionalCharts,
  toggleAdditionalChart,
  chartHeight,
  timelineButtonsRef,
  addToChartRef,
  additionalChartsContainerRef ,
  isMobile,
  hoveredPoint,
  setHoveredPoint,
  hoveredNews,
  setHoveredNews 
}) {
  const [activeTf, setActiveTf] = useState(timeframe);
  const [hoveredTf, setHoveredTf] = useState(null);
  
  const chartRef = useRef(null);
  const containerRef = useRef(null);

  const drawChart = useCallback(() => {
    const canvas = chartRef.current;
    const container = containerRef.current;
    if (!canvas || !container) return;
    
    const ctx = canvas.getContext('2d');
    
    // Use the calculated chartHeight directly instead of container rect
    const displayWidth = container.clientWidth;
    const displayHeight = chartHeight; // Use prop instead of container height
    
    // Calculate control bar height dynamically
    const controlsHeight = addToChartRef.current ? addToChartRef.current.offsetHeight + 16 : 60;
    
    // Main chart takes most space, leaving room for additional charts and controls
    const additionalChartHeight = additionalCharts.filter(chart => chart !== 'volume').length * 80;
    const mainChartHeight = Math.max(200, displayHeight - additionalChartHeight - controlsHeight);
    
    // Proper canvas sizing with device pixel ratio
    canvas.style.width = displayWidth + 'px';
    canvas.style.height = displayHeight + 'px';
    
    const scale = window.devicePixelRatio || 1;
    canvas.width = displayWidth * scale;
    canvas.height = displayHeight * scale;
    
    ctx.scale(scale, scale);
    ctx.clearRect(0, 0, displayWidth, displayHeight);

    const filteredData = data;
    const filteredNews = newsData.filter(news => {
      const newsDate = new Date(news.date);
      return newsDate <= currentDate && filteredData.some(d => new Date(d.date) >= newsDate);
    });

    if (filteredData.length < 2) return;

    // Calculate price range with zoom
    const prices = filteredData.map(item => item.price);
    const basePriceRange = Math.max(...prices) - Math.min(...prices);
    const zoomedPriceRange = basePriceRange / zoom;
    const avgPrice = (Math.max(...prices) + Math.min(...prices)) / 2;
    const minPrice = avgPrice - zoomedPriceRange / 2;
    const maxPrice = avgPrice + zoomedPriceRange / 2;

    // Draw gridlines for main chart
    ctx.strokeStyle = '#333';
    ctx.lineWidth = 1;

    // Vertical gridlines
    for (let i = 0; i <= 10; i++) {
      const x = (displayWidth / 10) * i;
      ctx.beginPath();
      ctx.moveTo(x, 0);
      ctx.lineTo(x, mainChartHeight);
      ctx.stroke();
    }

    // Horizontal gridlines
    for (let i = 0; i <= 8; i++) {
      const y = (mainChartHeight / 8) * i;
      ctx.beginPath();
      ctx.moveTo(0, y);
      ctx.lineTo(displayWidth, y);
      ctx.stroke();
    }

    // Draw X-axis date labels
    ctx.fillStyle = '#888';
    ctx.font = `${isMobile ? '10px' : '11px'} -apple-system, BlinkMacSystemFont, sans-serif`;
    ctx.textAlign = 'center';
    
    const labelCount = isMobile ? 4 : 6;
    for (let i = 0; i <= labelCount; i++) {
      const dataIndex = Math.floor((filteredData.length - 1) * (i / labelCount));
      if (dataIndex < filteredData.length) {
        const x = (displayWidth / Math.max(filteredData.length - 1, 1)) * dataIndex;
        const date = new Date(filteredData[dataIndex].date);
        const dateStr = date.toLocaleDateString('en-US', { 
          month: 'short', 
          day: isMobile ? undefined : 'numeric',
          year: filteredData.length > 100 ? '2-digit' : undefined 
        });
        ctx.fillText(dateStr, x, mainChartHeight + 15);
      }
    }

    // Draw Y-axis price labels
    ctx.textAlign = 'right';
    for (let i = 0; i <= 4; i++) {
      const price = minPrice + (maxPrice - minPrice) * (i / 4);
      const y = mainChartHeight - ((price - minPrice) / (maxPrice - minPrice)) * (mainChartHeight * 0.9);
      ctx.fillText(`$${price.toFixed(0)}`, displayWidth - 5, y + 4);
    }

    // Draw volume bars (behind main line)
    if (additionalCharts.includes('volume')) {
      const volumes = filteredData.map(item => item.volume);
      const maxVolume = Math.max(...volumes);
      
      ctx.fillStyle = 'rgba(100, 100, 100, 0.3)';
      filteredData.forEach((item, index) => {
        const x = (displayWidth / Math.max(filteredData.length - 1, 1)) * index;
        const barHeight = (item.volume / maxVolume) * mainChartHeight * 0.3;
        const barWidth = Math.max(1, displayWidth / filteredData.length * 0.8);
        
        ctx.fillRect(x - barWidth/2, mainChartHeight - barHeight, barWidth, barHeight);
      });
    }

    // Draw stock price line
    ctx.strokeStyle = '#00ff88';
    ctx.lineWidth = isMobile ? 2 : 3;
    ctx.beginPath();

    const points = [];
    filteredData.forEach((item, index) => {
      const x = (displayWidth / Math.max(filteredData.length - 1, 1)) * index;
      const y = mainChartHeight - ((item.price - minPrice) / (maxPrice - minPrice)) * (mainChartHeight * 0.9);
      
      points.push({ x, y, price: item.price, date: item.date });
      
      if (index === 0) {
        ctx.moveTo(x, y);
      } else {
        ctx.lineTo(x, y);
      }
    });

    ctx.stroke();

    // Draw news points
    ctx.fillStyle = '#ff6b6b';
    const newsPoints = [];
    filteredNews.forEach(news => {
      const newsDate = new Date(news.date);
      const dataIndex = filteredData.findIndex(item => new Date(item.date) >= newsDate);
      if (dataIndex !== -1) {
        const x = (displayWidth / Math.max(filteredData.length - 1, 1)) * dataIndex;
        const priceAtNews = filteredData[dataIndex].price;
        const y = mainChartHeight - ((priceAtNews - minPrice) / (maxPrice - minPrice)) * (mainChartHeight * 0.9);
        
        ctx.beginPath();
        ctx.arc(x, y, 8, 0, 2 * Math.PI);
        ctx.fill();
        
        // Draw "N" inside the circle
        ctx.fillStyle = '#ffffff';
        ctx.font = 'bold 10px Arial';
        ctx.textAlign = 'center';
        ctx.fillText('N', x, y + 3);
        ctx.fillStyle = '#ff6b6b';
        
        newsPoints.push({ x, y, news });
      }
    });

    // Draw additional charts below main chart
    let yOffset = mainChartHeight + 30;
    
    additionalCharts.forEach((chartType, index) => {
      if (chartType === 'volume') return; // Volume is drawn as bars behind main chart
      
      const chartHeight = 60;
      const values = filteredData.map(item => item[chartType] || 0);
      const minValue = Math.min(...values);
      const maxValue = Math.max(...values);
      const valueRange = maxValue - minValue || 1;
      
      // Draw chart background
      ctx.fillStyle = 'rgba(50, 50, 50, 0.2)';
      ctx.fillRect(0, yOffset, displayWidth, chartHeight);
      
      // Draw chart border
      ctx.strokeStyle = '#555';
      ctx.lineWidth = 1;
      ctx.strokeRect(0, yOffset, displayWidth, chartHeight);
      
      // Draw chart line
      ctx.strokeStyle = chartType === 'netIncome' ? '#ffaa00' : '#00aaff';
      ctx.lineWidth = 2;
      ctx.beginPath();
      
      filteredData.forEach((item, index) => {
        const x = (displayWidth / Math.max(filteredData.length - 1, 1)) * index;
        const y = yOffset + chartHeight - ((item[chartType] - minValue) / valueRange) * (chartHeight * 0.8);
        
        if (index === 0) {
          ctx.moveTo(x, y);
        } else {
          ctx.lineTo(x, y);
        }
      });
      
      ctx.stroke();
      
      // Chart label
      ctx.fillStyle = '#ffffff';
      ctx.font = '12px Arial';
      ctx.textAlign = 'left';
      const labelText = chartType.charAt(0).toUpperCase() + chartType.slice(1).replace(/([A-Z])/g, ' $1');
      ctx.fillText(labelText, 5, yOffset + 15);
      
      yOffset += chartHeight + 10;
    });

    // Store points for hover detection
    canvas.points = points;
    canvas.newsPoints = newsPoints;

    // Current price label
    ctx.fillStyle = '#00ff88';
    ctx.font = `${isMobile ? '12px' : '14px'} -apple-system, BlinkMacSystemFont, sans-serif`;
    ctx.textAlign = 'right';
    
    if (filteredData.length > 0) {
      const currentPrice = filteredData[filteredData.length - 1].price;
      ctx.fillText(`$${currentPrice.toFixed(2)}`, displayWidth - 10, 20);
    }

  }, [data, newsData, currentDate, zoom, additionalCharts, isMobile]);

  const handleMouseMove = useCallback((e) => {
    const canvas = chartRef.current;
    if (!canvas || !canvas.points) return;

    const rect = canvas.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    // Check for price point hover
    const point = canvas.points.find(p => 
      Math.abs(p.x - x) < 10 && Math.abs(p.y - y) < 10
    );
    
    if (point) {
      setHoveredPoint({
        x: e.clientX,
        y: e.clientY,
        price: point.price,
        date: point.date
      });
    } else {
      setHoveredPoint(null);
    }

    // Check for news point hover with better detection
    const newsPoint = canvas.newsPoints?.find(np => 
      Math.abs(np.x - x) < 12 && Math.abs(np.y - y) < 12
    );
    
    if (newsPoint) {
      setHoveredNews({
        x: e.clientX,
        y: e.clientY,
        headline: newsPoint.news.headline,
        body: newsPoint.news.body,
        date: newsPoint.news.date
      });
    } else {
      setHoveredNews(null);
    }
  }, [setHoveredPoint, setHoveredNews]);

  const handleWheel = useCallback((e) => {
    e.preventDefault();
    const zoomFactor = e.deltaY > 0 ? 0.9 : 1.1;
    setZoom(prev => Math.max(0.5, Math.min(5, prev * zoomFactor)));
  }, [setZoom]);

  useEffect(() => {
    drawChart();
  }, [drawChart]);

  const chartTypes = [
    { key: 'volume', label: 'Volume' },
    { key: 'netIncome', label: 'Net Income' },
    { key: 'assets', label: 'Assets' }
  ];

  return (
    <div
      className="stock-chart"
      ref={containerRef}
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        color: '#ffffff',
        minHeight: 0
      }}
    >
      {/* Chart Header */}
      <div
        className="chart-header"
        style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: isMobile ? 'flex-start' : 'center',
          justifyContent: 'space-between',
          color: '#ffffff',
          flexWrap: 'wrap',
          gap: '8px',
          paddingBottom: 16,
          marginBottom: 10,
          flexShrink: 0 // Prevent compression
        }}
      >
        <h3 style={{
          color: '#ffffff',
          fontSize: isMobile ? '1.2em' : '1.4em',
          margin: 0
        }}>
          Stock Chart
        </h3>
        <div
          ref={timelineButtonsRef}
          className="timeframe-buttons"
          style={{
            display: 'flex',
            gap: isMobile ? '4px' : '8px',
            flexWrap: 'wrap'
          }}
        >
          {/* Timeframe buttons */}
          {['5D', '1M', '3M', '6M', '1Y', '3Y', '5Y', 'Max'].map(tf => (
            <button
              key={tf}
              className="timeframe-btn"
              onClick={() => {
                setTimeframe(tf);
                setActiveTf(tf);
              }}
              onMouseEnter={() => setHoveredTf(tf)}
              onMouseLeave={() => setHoveredTf(null)}
              onFocus={() => setHoveredTf(tf)}
              onBlur={() => setHoveredTf(null)}
              style={{
                background:
                  activeTf === tf || hoveredTf === tf
                    ? '#0fa966'
                    : '#222326',
                color: '#ffffff',
                border: 'none',
                borderRadius: 8,
                padding: isMobile ? '4px 8px' : '6px 12px',
                fontWeight: 500,
                cursor: 'pointer',
                transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                minHeight: 32,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: isMobile ? '0.8em' : '0.9em',
                transform: (activeTf === tf || hoveredTf === tf)
                  ? 'translateY(-1px)'
                  : 'translateY(0)'
              }}
            >
              {tf}
            </button>
          ))}
        </div>
      </div>
      
      {/* Chart Container - takes remaining space */}
      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        position: 'relative'
      }}>
        {/* Canvas Container */}
        <div style={{
          flex: 1,
          background: '#141415',
          borderRadius: '16px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.12)',
          marginBottom: '8px',
          minHeight: '200px',
          overflow: 'hidden'
        }}>
          <canvas
            ref={chartRef}
            className="chart-canvas"
            style={{ 
              width: '100%', 
              height: '100%',
              display: 'block'
            }}
            onMouseMove={handleMouseMove}
            onWheel={handleWheel}
          />
        </div>

        {/* Chart Controls - in document flow below chart */}
        <div 
          ref={addToChartRef}
          style={{ 
            flexShrink: 0,
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            gap: '15px', 
            borderTop: '1px solid #333', 
            paddingTop: '8px',
            paddingBottom: '8px',
            flexWrap: 'wrap',
            backgroundColor: '#191a1e',
            borderRadius: '0 0 16px 16px'
          }}
        >
          <span style={{ 
            fontSize: isMobile ? '0.9em' : '1em',
            color: '#ccc',
            marginRight: 5
          }}>
            Add to Chart:
          </span>
          {chartTypes.map(chart => (
            <label key={chart.key} style={{
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
              fontSize: isMobile ? '0.8em' : '0.9em',
              color: '#ccc'
            }}>
              <input
                type="checkbox"
                checked={additionalCharts.includes(chart.key)}
                onChange={() => toggleAdditionalChart(chart.key)}
                style={{ 
                  marginRight: 5,
                  transform: 'scale(0.9)'
                }}
              />
              {chart.label}
            </label>
          ))}
        </div>
      </div>

      {/* Hover tooltips */}
      {hoveredPoint && (
        <div
          className="price-tooltip"  
          style={{
            position: 'fixed',
            left: hoveredPoint.x + 10,
            top: hoveredPoint.y - 40,
            background: 'rgba(0, 0, 0, 0.9)',
            color: 'white',
            padding: '8px 12px',
            borderRadius: 6,
            fontSize: 12,
            pointerEvents: 'none',
            zIndex: 1000,
            whiteSpace: 'nowrap'
          }}
        >
          <div>${hoveredPoint.price.toFixed(2)}</div>
          <div>{new Date(hoveredPoint.date).toLocaleDateString()}</div>
        </div>
      )}

      {hoveredNews && (
        <div
          className="news-tooltip"
          style={{
            position: 'fixed',
            left: hoveredNews.x + 10,
            top: hoveredNews.y - 60,
            background: 'rgba(0, 0, 0, 0.95)',
            color: 'white',
            padding: 12,
            borderRadius: 8,
            fontSize: 12,
            pointerEvents: 'none',
            zIndex: 1000,
            maxWidth: 300,
            border: '1px solid #ff6b6b'
          }}
        >
          <div style={{ fontWeight: 'bold', marginBottom: 4 }}>
            {hoveredNews.headline}
          </div>
          <div style={{ fontSize: 10, opacity: 0.8 }}>
            {new Date(hoveredNews.date).toLocaleDateString()}
          </div>
        </div>
      )}
    </div>
  );
}

function TradingScreen({ isMobile, dwidth, dheight }) {
  const [funds, setFunds] = useState(100);
  const [marbles, setMarbles] = useState([]);
  const [allocations, setAllocations] = useState([5, 5, 5, 5]);
  const [roundNumber, setRoundNumber] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [roundResults, setRoundResults] = useState([null, null, null, null]);
  const [cumulativeReturns, setCumulativeReturns] = useState([0, 0, 0, 0]);
  const [totalRounds, setTotalRounds] = useState([0, 0, 0, 0]);

  const marbleColors = ['#dd3333', '#4444ff', '#22dd22', '#cccc00'];
  const marbleNames = ['Red', 'Blue', 'Green', 'Yellow'];

  // Initialize marbles with random probabilities that sum to expected value of 0
  useEffect(() => {
    const generateMarbles = () => {
      // Each marble has a win probability (double) or lose probability (keep 10%)
      // Win return: 100% gain (2x), Lose return: -90% loss (0.1x)
      // Expected value = p * 1.0 + (1-p) * (-0.9) = p - 0.9 + 0.9p = 1.9p - 0.9
      // For sum of expected values = 0: sum(1.9p_i - 0.9) = 0
      // 1.9 * sum(p_i) - 3.6 = 0
      // sum(p_i) = 3.6/1.9 ≈ 1.895
      
      // Generate 4 random probabilities that sum to 1.895
      let probs = [];
      let sum = 0;
      for (let i = 0; i < 3; i++) {
        const p = Math.random() * 0.6 + 0.1; // Random between 0.1 and 0.7
        probs.push(p);
        sum += p;
      }
      probs.push(1.895 - sum); // Last probability makes sum = 1.895
      
      // Shuffle the probabilities
      probs.sort(() => Math.random() - 0.5);
      
      // Clamp probabilities to reasonable range (0.1 to 0.9)
      probs = probs.map(p => Math.max(0.1, Math.min(0.9, p)));
      
      // Adjust to make sum exactly 1.895
      const actualSum = probs.reduce((a, b) => a + b, 0);
      probs = probs.map(p => p * (1.895 / actualSum));
      
      return probs.map((winProb, i) => ({
        id: i,
        color: marbleColors[i],
        name: marbleNames[i],
        winProbability: winProb,
        winReturn: 1.0, // 100% gain (doubles)
        loseReturn: -0.9 // -90% loss (keeps 10%)
      }));
    };
    
    const newMarbles = generateMarbles();
    setMarbles(newMarbles);
  }, []);

  const handleAllocationChange = (index, value) => {
    // Remove dollar sign and parse
    const numValue = parseFloat(value.toString().replace(/[$,]/g, '')) || 0;
    
    // Round to nearest $5 increment
    const rounded = Math.max(0, Math.round(numValue / 5) * 5);
    
    const newAllocations = [...allocations];
    newAllocations[index] = rounded;
    setAllocations(newAllocations);
  };

  const getTotalAllocated = () => {
    return allocations.reduce((sum, val) => sum + val, 0);
  };

  const handleGo = () => {
    const totalAllocated = getTotalAllocated();
    
    // Check minimum bet requirement
    for (let i = 0; i < allocations.length; i++) {
      if (allocations[i] > 0 && allocations[i] < 5) {
        alert(`Minimum bet is $5 per marble. ${marbleNames[i]} marble has $${allocations[i].toFixed(2)} allocated.`);
        return;
      }
    }
    
    if (totalAllocated > funds) {
      alert(`Total allocation ($${totalAllocated.toFixed(2)}) exceeds available funds ($${funds.toFixed(2)})`);
      return;
    }
    
    if (totalAllocated === 0) {
      alert('Please allocate funds to at least one marble');
      return;
    }

    setIsAnimating(true);
    
    // Calculate results for each marble
    const results = marbles.map((marble, i) => {
      const allocation = allocations[i];
      if (allocation === 0) return { won: false, return: 0, newAmount: 0 };
      
      const won = Math.random() < marble.winProbability;
      const returnRate = won ? marble.winReturn : marble.loseReturn;
      const profit = allocation * returnRate;
      const newAmount = allocation + profit;
      
      return {
        won,
        return: returnRate,
        newAmount,
        profit
      };
    });

    setRoundResults(results);
    
    // Update cumulative returns and total rounds
    const newCumulativeReturns = [...cumulativeReturns];
    const newTotalRounds = [...totalRounds];
    
    results.forEach((result, i) => {
      if (allocations[i] > 0) {
        newCumulativeReturns[i] += result.return;
        newTotalRounds[i] += 1;
      }
    });
    
    setCumulativeReturns(newCumulativeReturns);
    setTotalRounds(newTotalRounds);
    
    // Animate and update funds after delay
    setTimeout(() => {
      const totalProfit = results.reduce((sum, r) => sum + (r.profit || 0), 0);
      const newFunds = funds - totalAllocated + results.reduce((sum, r) => sum + (r.newAmount || 0), 0);
      setFunds(newFunds);
      setRoundNumber(roundNumber + 1);
      setIsAnimating(false);
      setRoundResults([null, null, null, null]);
      // Keep allocations from previous round
    }, 2000);
  };

  const getAverageReturn = (marbleIndex) => {
    if (totalRounds[marbleIndex] === 0) return 0;
    return cumulativeReturns[marbleIndex] / totalRounds[marbleIndex];
  };

  const getConfidenceInterval = (marbleIndex) => {
    const n = totalRounds[marbleIndex];
    if (n === 0) return { lower: 0, upper: 0 };
    if (n === 1) return { lower: getAverageReturn(marbleIndex), upper: getAverageReturn(marbleIndex) };
    
    const mean = getAverageReturn(marbleIndex);
    
    // Calculate sample variance
    // For binary outcomes: variance = p * (1-p) * (win_return - lose_return)^2
    // We'll use the sample data to estimate
    // Each outcome is either +1.0 or -0.9, so variance of individual returns
    const winReturn = 1.0;
    const loseReturn = -0.9;
    
    // Estimate variance: for a binomial-like scenario with two outcomes
    // We need to estimate p from the mean
    // mean = p * winReturn + (1-p) * loseReturn
    // mean = p * 1.0 + (1-p) * (-0.9)
    // mean = p - 0.9 + 0.9p = 1.9p - 0.9
    // p = (mean + 0.9) / 1.9
    const estimatedP = Math.max(0, Math.min(1, (mean + 0.9) / 1.9));
    
    // Variance = p(1-p)(r1-r2)^2 where r1 and r2 are the two outcomes
    const variance = estimatedP * (1 - estimatedP) * Math.pow(winReturn - loseReturn, 2);
    const standardError = Math.sqrt(variance / n);
    
    // 95% confidence interval uses z-score of 1.96
    const marginOfError = 1.96 * standardError;
    
    return {
      lower: mean - marginOfError,
      upper: mean + marginOfError
    };
  };

  if (marbles.length === 0) {
    return <div style={{ color: '#fff', padding: 40 }}>Loading...</div>;
  }

  return (
    <div style={{
      height: 'calc(100% - 80px)',
      padding: isMobile ? '20px' : '40px',
      color: '#fff',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      overflow: 'auto'
    }}>
      <div style={{
        maxWidth: 1200,
        width: '100%'
      }}>
        {/* Header */}
        <div style={{
          background: '#191a1e',
          borderRadius: '16px',
          border: '1.5px solid #27274a',
          padding: isMobile ? '20px' : '30px',
          marginBottom: 30,
          textAlign: 'center'
        }}>
          <h2 style={{ 
            margin: 0,
            fontSize: isMobile ? '1.5em' : '2em',
            color: '#00ff88'
          }}>Marble Trading Game</h2>
        </div>

        {/* Instructions */}
        <div style={{
          background: '#191a1e',
          borderRadius: '16px',
          border: '1.5px solid #27274a',
          padding: isMobile ? '15px 20px' : '20px 30px',
          marginBottom: 30,
          fontSize: isMobile ? '0.9em' : '1em',
          lineHeight: 1.6
        }}>
          <h3 style={{
            margin: '0 0 12px 0',
            fontSize: '1.2em',
            color: '#00ff88'
          }}>How to Play</h3>
          <ul style={{
            margin: 0,
            paddingLeft: 20,
            color: '#ccc'
          }}>
            <li style={{ marginBottom: 8 }}>You start with $100. Your goal is to grow your funds.</li>
            <li style={{ marginBottom: 8 }}>Each round, allocate any amount to the four marbles in <span style={{ color: '#ffaa00', fontWeight: 'bold' }}>$5 increments</span>. Minimum bet is <span style={{ color: '#ffaa00', fontWeight: 'bold' }}>$5</span> per marble if you choose to bet on it (or $0 to skip). Total allocation cannot exceed available funds.</li>
            <li style={{ marginBottom: 8 }}>Each marble has hidden win/loss probabilities. When you win, you <span style={{ color: '#00ff88', fontWeight: 'bold' }}>double your bet (+100% return)</span>. When you lose, you <span style={{ color: '#ff4444', fontWeight: 'bold' }}>keep only 10% (-90% return)</span>.</li>
            <li style={{ marginBottom: 8 }}>Click <span style={{ fontWeight: 'bold' }}>GO</span> to play the round and see your results.</li>
            <li>Track the average return and 95% confidence interval for each marble to inform your strategy!</li>
          </ul>
        </div>

        {/* Marbles Row */}
        <div style={{
          background: '#191a1e',
          borderRadius: '16px',
          border: '1.5px solid #27274a',
          padding: isMobile ? '20px' : '30px',
          marginBottom: 30,
          position: 'relative'
        }}>
          {/* Available Funds - Top Left */}
          <div style={{
            position: 'absolute',
            top: isMobile ? '15px' : '20px',
            left: isMobile ? '15px' : '20px',
            fontSize: isMobile ? '0.9em' : '1em',
            fontWeight: 'bold',
            color: '#00ff88'
          }}>
            Funds: ${funds.toFixed(2)}
          </div>

          {/* Round Count - Top Right */}
          <div style={{
            position: 'absolute',
            top: isMobile ? '15px' : '20px',
            right: isMobile ? '15px' : '20px',
            fontSize: isMobile ? '0.9em' : '1em',
            fontWeight: 'bold',
            color: '#ccc'
          }}>
            Round: {roundNumber}
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
            gap: isMobile ? 15 : 20,
            marginTop: isMobile ? '25px' : '30px'
          }}>
            {marbles.map((marble, index) => (
              <div key={marble.id} style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                position: 'relative'
              }}>
                {/* Marble Visual with Amount Inside */}
                <div style={{
                  width: isMobile ? 60 : 80,
                  height: isMobile ? 60 : 80,
                  borderRadius: '50%',
                  background: `radial-gradient(circle at 30% 30%, ${marble.color}, ${marble.color}dd)`,
                  boxShadow: `0 4px 20px ${marble.color}66`,
                  marginBottom: 15,
                  transition: 'all 0.3s ease',
                  transform: isAnimating && allocations[index] > 0 ? 'scale(1.15)' : 'scale(1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: isMobile ? '1em' : '1.2em',
                  fontWeight: 'bold',
                  color: '#fff',
                  textShadow: '0 2px 4px rgba(0,0,0,0.5)',
                  opacity: getTotalAllocated() > funds ? 0.5 : 1
                }}>
                  ${allocations[index]}
                </div>

                {/* Up/Down Buttons Side by Side */}
                <div style={{ display: 'flex', gap: '6px', marginBottom: 8 }}>
                  <button
                    onClick={() => handleAllocationChange(index, Math.max(0, allocations[index] - 5))}
                    disabled={isAnimating}
                    style={{
                      padding: isMobile ? '6px 12px' : '8px 16px',
                      fontSize: isMobile ? '1em' : '1.2em',
                      fontWeight: 'bold',
                      background: isAnimating ? '#333' : '#00ff88',
                      color: isAnimating ? '#666' : '#1a1a2e',
                      border: 'none',
                      borderRadius: '6px',
                      cursor: isAnimating ? 'not-allowed' : 'pointer',
                      transition: 'all 0.2s ease',
                      lineHeight: 1
                    }}
                  >
                    ▼
                  </button>
                  <button
                    onClick={() => handleAllocationChange(index, allocations[index] + 5)}
                    disabled={isAnimating || getTotalAllocated() + 5 > funds}
                    style={{
                      padding: isMobile ? '6px 12px' : '8px 16px',
                      fontSize: isMobile ? '1em' : '1.2em',
                      fontWeight: 'bold',
                      background: (isAnimating || getTotalAllocated() + 5 > funds) ? '#333' : '#00ff88',
                      color: (isAnimating || getTotalAllocated() + 5 > funds) ? '#666' : '#1a1a2e',
                      border: 'none',
                      borderRadius: '6px',
                      cursor: (isAnimating || getTotalAllocated() + 5 > funds) ? 'not-allowed' : 'pointer',
                      transition: 'all 0.2s ease',
                      lineHeight: 1
                    }}
                  >
                    ▲
                  </button>
                </div>

                {/* 0 and Max Buttons */}
                <div style={{ display: 'flex', gap: '6px', marginBottom: 12 }}>
                  <button
                    onClick={() => handleAllocationChange(index, 0)}
                    disabled={isAnimating}
                    style={{
                      padding: isMobile ? '4px 10px' : '6px 14px',
                      fontSize: isMobile ? '0.85em' : '0.95em',
                      fontWeight: 'bold',
                      background: isAnimating ? '#333' : '#444',
                      color: isAnimating ? '#666' : '#ccc',
                      border: '1px solid #555',
                      borderRadius: '6px',
                      cursor: isAnimating ? 'not-allowed' : 'pointer',
                      transition: 'all 0.2s ease',
                      lineHeight: 1,
                      flex: 1
                    }}
                  >
                    0
                  </button>
                  <button
                    onClick={() => {
                      const othersTotal = allocations.reduce((sum, val, i) => i === index ? sum : sum + val, 0);
                      const maxValue = Math.max(0, funds - othersTotal);
                      handleAllocationChange(index, maxValue);
                    }}
                    disabled={isAnimating}
                    style={{
                      padding: isMobile ? '4px 10px' : '6px 14px',
                      fontSize: isMobile ? '0.85em' : '0.95em',
                      fontWeight: 'bold',
                      background: isAnimating ? '#333' : '#444',
                      color: isAnimating ? '#666' : '#ccc',
                      border: '1px solid #555',
                      borderRadius: '6px',
                      cursor: isAnimating ? 'not-allowed' : 'pointer',
                      transition: 'all 0.2s ease',
                      lineHeight: 1,
                      flex: 1
                    }}
                  >
                    Max
                  </button>
                </div>

                {/* Statistics */}
                <div style={{
                  fontSize: isMobile ? '0.75em' : '0.85em',
                  color: '#ccc',
                  textAlign: 'center',
                  width: '100%'
                }}>
                  <div style={{ 
                    marginBottom: 4,
                    fontWeight: 'bold',
                    color: getAverageReturn(index) === 0 ? '#fff' : (getAverageReturn(index) >= 0 ? '#00ff88' : '#ff4444')
                  }}>
                    {getAverageReturn(index) >= 0 ? '+' : ''}{(getAverageReturn(index) * 100).toFixed(1)}%
                  </div>
                  {totalRounds[index] > 0 && (
                    <div style={{ fontSize: '0.9em', color: '#888' }}>
                      ({totalRounds[index]} rounds)
                    </div>
                  )}
                  {totalRounds[index] > 0 && (
                    <div style={{ fontSize: '0.85em', color: '#666', marginTop: 2 }}>
                      [{(getConfidenceInterval(index).lower * 100).toFixed(1)}%, {(getConfidenceInterval(index).upper * 100).toFixed(1)}%]
                    </div>
                  )}
                </div>

                {/* Animation Result */}
                {isAnimating && roundResults[index] && allocations[index] > 0 && (
                  <div style={{
                    position: 'absolute',
                    top: isMobile ? '25px' : '35px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    fontSize: isMobile ? '1.5em' : '2em',
                    fontWeight: 'bold',
                    color: roundResults[index].won ? '#00ff88' : '#ff4444',
                    textShadow: `0 0 20px ${roundResults[index].won ? '#00ff8866' : '#ff444466'}`,
                    animation: 'pulse 0.5s ease-in-out infinite',
                    zIndex: 10,
                    pointerEvents: 'none'
                  }}>
                    {roundResults[index].won ? '+100%' : '-90%'}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Control Panel */}
        <div style={{
          background: '#191a1e',
          borderRadius: '16px',
          border: '1.5px solid #27274a',
          padding: isMobile ? '20px' : '30px',
          textAlign: 'center'
        }}>
          <div style={{
            fontSize: '1.1em',
            marginBottom: 15,
            color: getTotalAllocated() > funds ? '#ff4444' : '#ccc'
          }}>
            Total Allocated: ${getTotalAllocated().toFixed(2)} / ${funds.toFixed(2)}
          </div>
          
          <button
            onClick={handleGo}
            disabled={isAnimating || getTotalAllocated() === 0 || getTotalAllocated() > funds}
            style={{
              padding: isMobile ? '12px 40px' : '15px 60px',
              fontSize: isMobile ? '1.2em' : '1.5em',
              fontWeight: 'bold',
              background: (isAnimating || getTotalAllocated() === 0 || getTotalAllocated() > funds) ? '#333' : '#00ff88',
              color: (isAnimating || getTotalAllocated() === 0 || getTotalAllocated() > funds) ? '#666' : '#1a1a2e',
              border: 'none',
              borderRadius: '12px',
              cursor: (isAnimating || getTotalAllocated() === 0 || getTotalAllocated() > funds) ? 'not-allowed' : 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: (isAnimating || getTotalAllocated() === 0 || getTotalAllocated() > funds) ? 'none' : '0 4px 20px rgba(0, 255, 136, 0.3)'
            }}
          >
            {isAnimating ? 'Playing...' : 'GO'}
          </button>
        </div>
      </div>

      <style>
        {`
          @keyframes pulse {
            0%, 100% { transform: translate(-50%, -50%) scale(1); opacity: 1; }
            50% { transform: translate(-50%, -50%) scale(1.2); opacity: 0.8; }
          }
        `}
      </style>
    </div>
  );
}

export default DelFi;

